import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';
// Barra delgada + panel lateral (Drawer) del centro de acción del ticket.
// No roba espacio a la información del ticket: solo ocupa una línea; el contenido
// pesado (acciones, análisis IA, relacionados) vive en un Drawer que se abre a demanda.
import React, { useEffect, useState, useCallback } from 'react';
import {
  Paper, Box, Stack, Typography, Button, Chip, Drawer, IconButton,
} from '@mui/material';
import {
  Bolt as BoltIcon, Close as CloseIcon, AutoAwesome as AIIcon,
  AddTask as AddTaskIcon, Chat as ChatIcon,
} from '@mui/icons-material';
import { api } from '../../services/api';
import TicketActionCenter from './TicketActionCenter';
import TicketAIAnalysisCard from './TicketAIAnalysisCard';

export default function TicketActionBar({ ticket }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState({ tasks: 0, channels: 0 });

  const loadCounts = useCallback(() => {
    api.alarmTickets.ticketCollaboration(ticket.id)
      .then((r) => setCounts({ tasks: (r.data?.tasks || []).length, channels: (r.data?.channels || []).length }))
      .catch(() => {});
  }, [ticket.id]);

  useEffect(() => {
    loadCounts();
    const h = () => loadCounts();
    window.addEventListener('aps-ticket-collab-changed', h);
    return () => window.removeEventListener('aps-ticket-collab-changed', h);
  }, [loadCounts]);

  return (
    <>
      {/* Barra delgada (una sola línea) */}
      <Paper sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap',
        border: '1px solid', borderColor: 'rgba(211,47,47,0.25)',
        background: 'linear-gradient(90deg, rgba(211,47,47,0.06), transparent 70%)' }}>
        <BoltIcon color="primary" fontSize="small" />
        <Typography variant="subtitle2" fontWeight={700}>{t('hardcoded.components_tickets_ticketactionbar.centro_de_accion_del_ticket')}</Typography>
        <Chip size="small" icon={<AddTaskIcon sx={{ fontSize: 14 }} />} label={counts.tasks} variant="outlined" sx={{ height: 22 }} />
        <Chip size="small" icon={<ChatIcon sx={{ fontSize: 14 }} />} label={counts.channels} variant="outlined" sx={{ height: 22 }} />
        <Box sx={{ flex: 1 }} />
        <Button size="small" variant="contained" startIcon={<AIIcon />} onClick={() => setOpen(true)}>
          {t('hardcoded.components_tickets_ticketactionbar.acciones_e_ia')}</Button>
      </Paper>

      {/* Panel lateral con todo el contenido */}
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}
        PaperProps={{ sx: { width: { xs: '100%', sm: 500 }, maxWidth: '100%' } }}>
        <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 1, position: 'sticky', top: 0, zIndex: 2,
          color: '#fff', background: 'linear-gradient(135deg,#1a1a1a,#b71c1c)' }}>
          <BoltIcon />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="subtitle1" fontWeight={800} lineHeight={1.1}>{t('hardcoded.components_tickets_ticketactionbar.centro_de_accion')}</Typography>
            <Typography variant="caption" sx={{ opacity: 0.85 }}>{i18n.t('hardcoded.components_ai_aientitycards.ticket')}{ticket.ticket_number}</Typography>
          </Box>
          <IconButton onClick={() => setOpen(false)} sx={{ color: '#fff' }}><CloseIcon /></IconButton>
        </Box>
        <Box sx={{ p: 2, overflowY: 'auto' }}>
          {/* Se monta solo al abrir → el análisis IA se carga de forma perezosa */}
          {open && (
            <Stack spacing={1.5}>
              <TicketActionCenter ticket={ticket} />
              <TicketAIAnalysisCard ticket={ticket} />
            </Stack>
          )}
        </Box>
      </Drawer>
    </>
  );
}
